import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { StatusReservationTypeComponent } from '@ux/components/status-reservation-type/status-reservation-type.component';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { TagStatusDsComponent } from '@design-system/components/molecules/tag-status/tag-status.component';

@NgModule({
  declarations: [
    StatusReservationTypeComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    GlobalPipesModule,
    TagStatusDsComponent,
  ],
  exports: [
    StatusReservationTypeComponent
  ],
})
export class StatusReservationTypeModule { }
